import { render } from "./FullMenuLayout.vue?vue&type=template&id=0a0557be&scoped=true&ts=true"
import script from "./FullMenuLayout.vue?vue&type=script&lang=ts"
export * from "./FullMenuLayout.vue?vue&type=script&lang=ts"

import "./FullMenuLayout.vue?vue&type=style&index=0&id=0a0557be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0557be"]])

export default __exports__